import React from "react";
import { Card, CardBody, Alert, Input, Button } from "reactstrap";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import api from "../../../../Api.js";
import moment from 'moment';
import 'moment/locale/pt-br';
import ClipLoader from "react-spinners/ClipLoader";

moment.locale('pt-br');

class ModalTaskDeliveries extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            deliveries: [],
            loading: true,
            error: null,
            users: {},
            editingPoints: {},
            editingMode: {},
            editingRecuseObs: {},
            searchTerm: '',
            isPaneOpen: props.isOpen,
            isMobile: window.innerWidth < 768
        };
    }

    componentDidMount() {
        this.getDeliveries();
        window.addEventListener("resize", this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleResize = () => {
        this.setState({ isMobile: window.innerWidth < 768 });
    };

    componentDidUpdate(prevProps) {
        if (prevProps.isOpen !== this.props.isOpen) {
            this.setState({ isPaneOpen: this.props.isOpen });
        }
    }

    handlePaneClose = () => {
        this.setState({ isPaneOpen: false });
        setTimeout(() => {
            this.props.onClose();
        }, 300);
    };

    getDeliveries = () => {
        api.getTaskSubmissionsWithDetails(this.props.task.id)
            .then(response => {
                const taskDeliveries = response.data;
                
                const usersData = {};
                taskDeliveries.forEach(delivery => {
                    usersData[delivery.user] = { 
                        name: delivery.username || "Usuário não encontrado" 
                    };
                });
                
                console.log("Entregas processadas:", taskDeliveries);
                this.setState({ 
                    deliveries: taskDeliveries,
                    users: usersData,
                    loading: false 
                });
            })
            .catch(error => {
                console.error("Erro ao buscar entregas:", error);
                this.setState({ 
                    error: error.response?.data?.msg || "Erro ao carregar entregas",
                    loading: false 
                });
            });
    }

    downloadFile = (fileUrl, fileName) => {
        const baseUrl = window.sessionStorage.getItem('backend');
        const fullUrl = `${baseUrl}${fileUrl}`;
        window.open(fullUrl, '_blank');
    }

    handlePointsChange = (deliveryId, value) => {
        this.setState(prevState => ({
            editingPoints: {
                ...prevState.editingPoints,
                [deliveryId]: value
            }
        }));
    }

    toggleEditMode = (deliveryId) => {
        this.setState(prevState => ({
            editingMode: {
                ...prevState.editingMode,
                [deliveryId]: !prevState.editingMode[deliveryId]
            },
            editingPoints: {
                ...prevState.editingPoints,
                [deliveryId]: prevState.editingMode[deliveryId] ? undefined : this.state.deliveries.find(d => d.id === deliveryId)?.points || ''
            }
        }));
    }

    handleRecuseObsChange = (deliveryId, value) => {
        this.setState(prevState => ({
            editingRecuseObs: {
                ...prevState.editingRecuseObs,
                [deliveryId]: value
            }
        }));
    };

    savePoints = (delivery) => {
        const points = Number(this.state.editingPoints[delivery.id]);
        if (isNaN(points)) return;

        this.setState({ loading: true });

        let newStatus = delivery.status;
        if (points !== null && points !== undefined && points !== '') {
            newStatus = delivery.status === 'ATRASADO' ? 'ATRASADO' : 'resolvido';
        } else {
            newStatus = delivery.status === 'ATRASADO' ? 'ATRASADO' : 'pendente';
        }

        const updateData = {
            id: delivery.id,
            user: delivery.user,
            points: points,
            status: newStatus,
            file: delivery.file,
            obs: delivery.obs,
            recuse_obs: this.state.editingRecuseObs[delivery.id] || '',
            sendDate: delivery.sendDate,
            taskId: delivery.taskId
        };

        console.log('Dados sendo enviados:', updateData);

        api.putTaskUserSend(delivery.id, updateData)
            .then(() => {
                this.getDeliveries();
                window.swal.fire('Sucesso!', 'Nota e status atualizados com sucesso!', 'success');
            })
            .catch(error => {
                console.error('Erro:', error);
                window.swal.fire('Erro!', 'Não foi possível salvar as alterações.', 'error');
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    }

    filterDeliveries = () => {
        const { deliveries, users, searchTerm } = this.state;
        if (!searchTerm) return deliveries;
        
        return deliveries.filter(delivery => {
            const userName = users[delivery.user]?.name || '';
            return userName.toLowerCase().includes(searchTerm.toLowerCase());
        });
    }

    handleSearch = (event) => {
        this.setState({ searchTerm: event.target.value });
    }

    render() {
        const { loading, error, users, editingPoints, editingMode, editingRecuseObs, searchTerm, deliveries, isMobile } = this.state;
        const { translate, task } = this.props;
        const filteredDeliveries = this.filterDeliveries();

        const totalDeliveries = deliveries.length;
        const gradedDeliveries = deliveries.filter(d => d.points !== null && d.points !== undefined && d.points !== '').length;
        const pendingGrades = totalDeliveries - gradedDeliveries;

        return (
            <Card className="bg-secondary border-0 mb-0">
                <CardBody className={isMobile ? "px-2 py-3" : "px-lg-5 py-lg-5"}>
                    {error && <Alert color="danger">{error}</Alert>}
                    
                    {!loading && (
                        <div className="delivery-stats mb-4">
                            <div className={`row text-center ${isMobile ? 'mx-0' : ''}`}>
                                <div className={isMobile ? "col-4 px-1" : "col-4"}>
                                    <div className="card bg-gradient-primary border-0">
                                        <div className={isMobile ? "card-body py-2" : "card-body py-3"}>
                                            <h2 className={`text-white mb-0 ${isMobile ? 'h3' : ''}`}>{totalDeliveries}</h2>
                                            <p className={`text-white mb-0 ${isMobile ? 'small' : ''}`}>
                                                <i className="fas fa-file-alt mr-1"></i>
                                                {isMobile ? "Total" : "Entregas"}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className={isMobile ? "col-4 px-1" : "col-4"}>
                                    <div className="card bg-gradient-success border-0">
                                        <div className={isMobile ? "card-body py-2" : "card-body py-3"}>
                                            <h2 className={`text-white mb-0 ${isMobile ? 'h3' : ''}`}>{gradedDeliveries}</h2>
                                            <p className={`text-white mb-0 ${isMobile ? 'small' : ''}`}>
                                                <i className="fas fa-check-circle mr-1"></i>
                                                {isMobile ? "Corrig." : "Corrigidas"}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className={isMobile ? "col-4 px-1" : "col-4"}>
                                    <div className="card bg-gradient-warning border-0">
                                        <div className={isMobile ? "card-body py-2" : "card-body py-3"}>
                                            <h2 className={`text-white mb-0 ${isMobile ? 'h3' : ''}`}>{pendingGrades}</h2>
                                            <p className={`text-white mb-0 ${isMobile ? 'small' : ''}`}>
                                                <i className="fas fa-clock mr-1"></i>
                                                {isMobile ? "Pend." : "Pendentes"}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="mb-4">
                        <Input
                            type="text"
                            placeholder={translate?.pesquisar_usuario || "Pesquisar por usuário..."}
                            value={searchTerm}
                            onChange={this.handleSearch}
                            className="form-control-alternative"
                        />
                    </div>
                    
                    {loading ? (
                        <center><ClipLoader color={'#000'} loading={true} /></center>
                    ) : filteredDeliveries.length === 0 ? (
                        <center>{searchTerm ? (translate?.nenhum_resultado || "Nenhum resultado encontrado") : (translate?.nenhuma_entrega || "Nenhuma entrega encontrada")}</center>
                    ) : (
                        <div className={isMobile ? "deliveries-list" : "deliveries-grid"}>
                            {filteredDeliveries.map((delivery, index) => (
                                <Card key={index} className={`delivery-card mb-3 shadow-sm ${isMobile ? 'mx-0' : ''}`}>
                                    <CardBody className={isMobile ? "p-3" : ""}>
                                        <div className={`d-flex ${isMobile ? 'flex-column' : 'justify-content-between align-items-center'} mb-2`}>
                                            <h5 className={`mb-0 ${isMobile ? 'mb-2' : ''}`}>
                                                <i className="fas fa-user-circle mr-1"></i>
                                                {users[delivery.user]?.name || "Carregando..."}
                                            </h5>
                                            <div className={isMobile ? "d-flex mb-2" : ""}>
                                                <span className={`badge mr-2 ${delivery.status === 'ATRASADO' ? 'badge-warning' : 'badge-success'}`}>
                                                    {delivery.status}
                                                </span>
                                                {(!delivery.points && delivery.points !== 0) && (
                                                    <span className="badge badge-warning">
                                                        {translate?.aguardando_correcao || "Aguardando correção"}
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        <div className={`delivery-dates ${isMobile ? 'mb-2 small' : 'mb-3'}`}>
                                            <div className={`${isMobile ? 'd-flex flex-column' : 'd-flex'}`}>
                                                <div className={isMobile ? "mb-1" : "mr-4"}>
                                                    <div className="small text-muted">
                                                        <i className="ni ni-calendar-grid-58 mr-1"></i>
                                                        {isMobile ? "Início: " : ""}
                                                        {moment(task.dataInicial).format(isMobile ? 'DD/MM HH:mm' : 'DD/MM/YYYY HH:mm')}
                                                    </div>
                                                </div>
                                                <div className={isMobile ? "mb-1" : "mr-4"}>
                                                    <div className="small text-muted">
                                                        <i className="ni ni-calendar-grid-58 mr-1"></i>
                                                        {isMobile ? "Fim: " : ""}
                                                        {moment(task.dataFinal).format(isMobile ? 'DD/MM HH:mm' : 'DD/MM/YYYY HH:mm')}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="small text-muted">
                                                        <i className="fas fa-clock mr-1"></i>
                                                        {isMobile ? "Entrega: " : ""}
                                                        {moment(delivery.sendDate).format(isMobile ? 'DD/MM HH:mm' : 'DD/MM/YYYY HH:mm')}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="delivery-info mb-2">
                                            <div className={`info-item ${isMobile ? 'mt-1' : 'mt-2'}`}>
                                                <div className={`d-flex ${isMobile ? 'flex-column' : 'align-items-center'}`}>
                                                    {!editingMode[delivery.id] ? (
                                                        <>
                                                            <div className="d-flex align-items-center mb-2">
                                                                <i className="fas fa-star mr-2 text-warning"></i>
                                                                <span className="text-muted mr-2">
                                                                    Nota: {(!delivery.points && delivery.points !== 0) ? '-' : delivery.points}
                                                                </span>
                                                                <Button
                                                                    color="info"
                                                                    size="sm"
                                                                    onClick={() => this.toggleEditMode(delivery.id)}
                                                                    className={isMobile ? "btn-sm py-0 px-2" : ""}
                                                                >
                                                                    <i className="fas fa-edit"></i>
                                                                </Button>
                                                            </div>
                                                            {delivery.recuse_obs && (
                                                                <div className="text-danger mb-2 small">
                                                                    <i className="fas fa-exclamation-circle mr-1"></i>
                                                                    Obs: {delivery.recuse_obs}
                                                                </div>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <div className={`editing-container ${isMobile ? 'w-100' : 'd-flex align-items-center'}`}>
                                                            <div className={isMobile ? "mb-2 d-flex align-items-center" : ""}>
                                                                <Input
                                                                    type="number"
                                                                    min="0"
                                                                    max="10"
                                                                    step="0.1"
                                                                    className={`${isMobile ? "form-control-sm" : ""} mr-2`}
                                                                    style={{ width: isMobile ? '80px' : '80px' }}
                                                                    value={editingPoints[delivery.id] !== undefined ? 
                                                                        editingPoints[delivery.id] : 
                                                                        ''}
                                                                    onChange={(e) => this.handlePointsChange(delivery.id, e.target.value)}
                                                                    placeholder="Nota"
                                                                />
                                                                {isMobile && (
                                                                    <>
                                                                        <Button
                                                                            color="success"
                                                                            size="sm"
                                                                            className="mr-1 py-0 px-2"
                                                                            onClick={() => this.savePoints(delivery)}
                                                                            disabled={editingPoints[delivery.id] === undefined}
                                                                        >
                                                                            <i className="fas fa-save"></i>
                                                                        </Button>
                                                                        <Button
                                                                            color="danger"
                                                                            size="sm"
                                                                            className="py-0 px-2"
                                                                            onClick={() => this.toggleEditMode(delivery.id)}
                                                                        >
                                                                            <i className="fas fa-times"></i>
                                                                        </Button>
                                                                    </>
                                                                )}
                                                            </div>
                                                            <Input
                                                                type="textarea"
                                                                className={`${isMobile ? "form-control-sm mb-2" : "form-control-sm mr-2"}`}
                                                                style={{ width: isMobile ? '100%' : '200px', minHeight: isMobile ? '60px' : 'auto' }}
                                                                value={editingRecuseObs[delivery.id] || ''}
                                                                onChange={(e) => this.handleRecuseObsChange(delivery.id, e.target.value)}
                                                                placeholder="Observação de recusa (opcional)"
                                                            />
                                                            {!isMobile && (
                                                                <>
                                                                    <Button
                                                                        color="success"
                                                                        size="sm"
                                                                        className="mr-1"
                                                                        onClick={() => this.savePoints(delivery)}
                                                                        disabled={editingPoints[delivery.id] === undefined}
                                                                    >
                                                                        <i className="fas fa-save"></i>
                                                                    </Button>
                                                                    <Button
                                                                        color="danger"
                                                                        size="sm"
                                                                        onClick={() => this.toggleEditMode(delivery.id)}
                                                                    >
                                                                        <i className="fas fa-times"></i>
                                                                    </Button>
                                                                </>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {delivery.obs && (
                                            <div className={`delivery-obs mb-2 ${isMobile ? 'p-2 small' : ''}`}>
                                                <p className="text-muted mb-0">
                                                    <i className="fas fa-comment-alt mr-1"></i>
                                                    {delivery.obs}
                                                </p>
                                            </div>
                                        )}

                                        {delivery.link && (
                                            <div className="delivery-link mb-2 small">
                                                <p className="text-muted mb-0">
                                                    <i className="fas fa-link mr-1"></i>
                                                    <a href={delivery.link} target="_blank" rel="noopener noreferrer" title={delivery.link}>
                                                        {delivery.link.length > (isMobile ? 30 : 40) 
                                                            ? `${delivery.link.substring(0, isMobile ? 30 : 40)}...` 
                                                            : delivery.link}
                                                    </a>
                                                </p>
                                            </div>
                                        )}

                                        {delivery.file && (
                                            <button
                                                className={`btn btn-primary ${isMobile ? 'btn-sm btn-block mt-2' : 'btn-sm'}`}
                                                onClick={() => this.downloadFile(delivery.file, `entrega_${users[delivery.user]?.name}`)}
                                            >
                                                <i className="fas fa-download mr-1"></i>
                                                {translate?.baixar || "Baixar Arquivo"}
                                            </button>
                                        )}
                                    </CardBody>
                                </Card>
                            ))}
                        </div>
                    )}
                </CardBody>
                <style jsx="true">{`
                    @media (max-width: 767px) {
                        .deliveries-list {
                            display: flex;
                            flex-direction: column;
                        }
                        
                        .delivery-card {
                            margin-bottom: 0.75rem !important;
                            border-radius: 8px;
                        }
                        
                        .card-body {
                            padding: 0.75rem !important;
                        }
                        
                        .badge {
                            font-size: 0.65rem;
                            padding: 0.25rem 0.5rem;
                        }
                        
                        h5 {
                            font-size: 0.95rem;
                        }
                        
                        .small {
                            font-size: 0.75rem !important;
                        }
                        
                        .editing-container {
                            display: flex;
                            flex-direction: column;
                        }
                        
                        .delivery-obs {
                            background-color: rgba(0, 0, 0, 0.02);
                            border-radius: 4px;
                        }
                        
                        .btn-sm {
                            padding: 0.25rem 0.5rem;
                            font-size: 0.75rem;
                        }
                    }
                    
                    @media (min-width: 768px) {
                        .deliveries-grid {
                            display: grid;
                            grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
                            gap: 16px;
                        }
                    }
                `}</style>
            </Card>
        );
    }
}

export default ModalTaskDeliveries;
